import { TParsers } from '../types'
import { OpenAPIV2 } from 'openapi-types'

export const getTypeKeyFromDefinition = (
  definition: OpenAPIV2.DefinitionsObject[string],
): string => {
  if (Array.isArray(definition.enum)) {
    return 'enums'
  }

  return 'entities'
}

const DefinitionsParser: TParsers['definitions'] = (
  swaggerfiles,
  options = {},
) => {
  const definitions = swaggerfiles.definitions ?? {}
  const { entities, enums } = Object.keys(definitions).reduce(
    (acc, key) => {
      const type = getTypeKeyFromDefinition(definitions[key])
      return {
        ...acc,
        [type]: {
          ...acc[type],
          [key]: definitions[key],
        },
      }
    },
    {
      enums: {},
      entities: {},
    },
  )
  return {
    entities,
    enums,
  }
}

export default DefinitionsParser
